import React from "react";
import Head from "next/head";
import Full from "../layouts/Full";
import styles from "../styles/StockSmartPage.module.css";
import MustBeNonResidential from "../layouts/MustBeNonResidential";
import Unauthorized from "./401";

function StockSmartPage() {

  const [accountType, setAccountType] = React.useState(null);
  const [firstLoad, setFirstLoad] = React.useState(true);
  const [showUnauthorized, setShowUnauthorized] = React.useState(false);

  React.useEffect(() => {
    const account_info_cookie = document.cookie.replace(/(?:(?:^|.*;\s*)account_info\s*\=\s*([^;]*).*$)|^.*$/, "$1");

    if (account_info_cookie) {
      const account_info_array = decodeURIComponent(account_info_cookie).split('|')

      const account_type = account_info_array[1];

      setFirstLoad(false);
      setAccountType(account_type);
    }
  }, []);

  React.useEffect(() => {
    if (accountType == 'Residential' || (accountType == null && !firstLoad)) {
      setShowUnauthorized(true);
    }
  }, [accountType, firstLoad]);

  if (showUnauthorized) {
    return <Unauthorized />;
  }

  return (
    <>
      <Head>
        <title>FRP StockSmart</title>
        <meta
          name="description"
          content="FRP StockSmart — A powerful, web-based inventory system built specifically for fitness industry service companies."
        />
      </Head>

      <div className={styles.pageWrapper}>
        {/* Background pattern */}
        <div className={styles.backgroundPattern}></div>
        <div className={styles.backgroundImage}></div>

        <div className={styles.container}>
          {/* Left-side form */}
          <div className={styles.formCard}>
            <div className={styles.heroImage}>
              <a href='https://inv.frp1.com' target="_blank" rel="noopener noreferrer">
                <img
                  src="/ad_images/frp-stock-smart-logo.png"
                  alt="FRP StockSmart"
                />
              </a>
            </div>
            <div className={styles.imageTag}>Free Access!</div>

            <div className={styles.formContent}>
              <h2 className={styles.formHeading}>
                Check out FRP StockSmart, our inventory accuracy system built specifically for fitness service providers and dealers.
              </h2>

              <a href='https://inv.frp1.com' target="_blank" rel="noopener noreferrer">
                <button type="button" className={styles.submitButton}>
                  Click here to access FRP SmartStock!
                </button>
              </a>
            </div>
          </div>

          {/* Right-side content */}
          <div className={styles.content}>
            <h1 className={styles.title}>
              Introducing <strong>FRP StockSmart</strong>
            </h1>
            <p className={styles.subheading}>
              A powerful, web-based inventory control system built specifically
              for fitness industry service companies like yours.
            </p>

            <div className={styles.textBlock}>
              <p>
                For years, <strong>FitnessRepairParts.com</strong> has relied on
                a custom-built system to accurately manage over{" "}
                <strong>3 million parts</strong> in our own warehouse. It’s how
                we maintain speed, accuracy, and confidence at scale.
              </p>
              <br />
              <p>Now, we’re opening the door.</p>
              <br />
              <p>
                <strong>FRP StockSmart</strong> is a simplified,
                service-company–friendly version of that same proven technology —
                designed for technicians and service businesses that want
                accurate inventory without complexity. And we intend to keep it{" "}
                <strong>free forever</strong>.
              </p>

              <hr />

              <div className={styles.videoWrapper}>
                <iframe
                  src="https://www.youtube.com/embed/drQ0EjzEIaQ"
                  title="FRP StockSmart Overview"
                  allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>

              <h2 className={styles.heading}>What You Can Expect</h2>
              <p>
                <strong>Barcode Your Parts & Shelves</strong>
                <br />
                Scan parts in and out, track locations, and keep everything
                organized with ease.
              </p>
              <br />
              <p>
                <strong>Web-Based Access</strong>
                <br />
                View and manage your inventory from anywhere, on any device —
                shop, warehouse, or field.
              </p>
              <br />
              <p>
                <strong>Built on Proven Technology</strong>
                <br />
                Powered by the same system FRP uses to run one of the largest
                fitness parts operations in the industry.
              </p>
              <br />
              <p>
                <strong>Quick Start Resources</strong>
                <br />
                Step-by-step guidance with a ready-to-go YouTube playlist to
                help you set up and start using StockSmart fast.
              </p>

              <h2 className={styles.heading}>Why We Built It</h2>
              <p>
                Because accurate inventory eliminates guesswork.
                <br />
                Because the right part, at the right time, matters.
                <br />
                Because service companies deserve tools built by people who
                actually understand the work.
              </p>

              <div className={styles.gallery}>
                <img
                  src="/ad_images/warehouse-shelves.jpg"
                  alt="Warehouse shelves"
                />
                <img
                  src="/ad_images/fitness-repair-parts.png"
                  alt="Fitness parts"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

StockSmartPage.getLayout = function getLayout(page) {
  return (
    <Full>
      {page}
    </Full>
  );
}

export default StockSmartPage;